import * as React from 'react';
import {
	ClientSegmentationResult,
	ClientSegmentType,
	Metrics,
} from '@/interfaces';
import { getSegmentClientColor } from '@/lib';
import { BarChart } from '@/components/dashboard';

export const CaseMetricsClientSegmentation = ({
	clientSegmentation,
}: {
	clientSegmentation: ClientSegmentationResult[];
}) => {
	const getPercentageByName = (name: ClientSegmentType): number => {
		return (
			clientSegmentation.find((item) => item.segmentation_name === name)
				?.percentage || 0
		);
	};

	const segmentationList: Metrics[] = [
		{
			percentage: getPercentageByName('Repeat Customer'),
			title: 'Repeat Customers',
			color: getSegmentClientColor('Repeat Customer'),
		},
		{
			percentage: getPercentageByName('One-Time Customer'),
			title: 'One-Time Customers',
			color: getSegmentClientColor('One-Time Customer'),
		},
		{
			percentage: getPercentageByName('In-Progress Customer'),
			title: 'In-Progress Customers',
			color: getSegmentClientColor('In-Progress Customer'),
		},
		{
			percentage: getPercentageByName('Recently Registered Customer'),
			title: 'Recently Registered Customers',
			color: getSegmentClientColor('Recently Registered Customer'),
		},
		{
			percentage: getPercentageByName('Disengaged Customer'),
			title: 'Disengaged Customers',
			color: getSegmentClientColor('Disengaged Customer'),
		},
		{
			percentage: getPercentageByName('Flagged Customer'),
			title: 'Flagged Customers',
			color: getSegmentClientColor('Flagged Customer'),
		},
	];

	return (
		<div className="pl-4">
			<BarChart
				metricsArray={segmentationList}
				classNamePercentage="!text-start !text-[20px] !leading-[24px]"
				classNameContainer="gap-y-[29px]"
				classNameItem="h-[29px]"
			/>
		</div>
	);
};
